export enum DateDirection {
  Last = "Last",
  Next = "Next",
}
